import UploadingScreen from "./UploadingScreen";
export default UploadingScreen;
